import { render, staticRenderFns } from "./StoreSaleForm.vue?vue&type=template&id=b28057da&"
import script from "./StoreSaleForm.vue?vue&type=script&lang=js&"
export * from "./StoreSaleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports